import { DollarApollo } from "vue-apollo/types/vue-apollo";
import { FetchResult } from "apollo-link";
import Mutation from "./mutation.gql";

export interface Result {
  resetMe: string;
}

export const resetMe = async <V>(
  apollo: DollarApollo<V>,
  userId: string
): Promise<FetchResult<Result>> => {
  const result = apollo.mutate({
    mutation: Mutation,
    variables: { userId }
  });
  await apollo.provider.defaultClient.cache.reset();
  return result;
};
